import * as ServMasterModel from './ServiceMasterModel';

export interface ServiceContractModel {
    serviceMaster: ServMasterModel.ServiceMaster,
    id: string,
    startDate: string,
    expiryDate: string,
    contractAmount: number,
    contractDescription: string,
    maintenanceSchedulePendingCount: number,
    equipmentCoveredCount:number,
    contractStatus: string,
    cancelAmount: number,
    cancelDate?: string,
    allowToRenew: boolean,
    serviceType: string,
    numberOfSystem: number
}

export const initialState: ServiceContractModel = {
    serviceMaster: { ...ServMasterModel.initialState },
    id: '',
    startDate: '',
    expiryDate: '',
    contractAmount: 0,
    contractDescription: '',
    maintenanceSchedulePendingCount: 0,
    equipmentCoveredCount: 0,
    contractStatus: '',
    cancelAmount: 0,
    cancelDate: '',
    allowToRenew: false,
    serviceType: '',
    numberOfSystem: 0
};